import React, { useState, useRef, useEffect } from "react";
import { API_URL } from '../../Actions/Config'

function getTourCheck(dayTours, roundTours, excursions) {
  var list = false
  if (dayTours.length > 0 || roundTours.length > 0 || excursions.length > 0) {
    list = true
  }
  return list
}

export default function SearchForm() {
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const dropdownRefK = useRef(null);
  const inputRefK = useRef(null);
  const [locations, setLocations] = useState([]);
  const [dayTours, setDayTours] = useState([]);
  const [roundTours, setRoundTours] = useState([]);
  const [excursions, setExcursions] = useState([]);
  const [showPickupList, setShowPickupList] = useState(false);
  const [showKeyList, setShowKeyList] = useState(false);
  const [locationInput, setLocationInput] = useState("");
  const [keyword, setKeyword] = useState("");

  const url = "/";

  const searchPickUp = (e) => {
    const value = e.target.value;
    setLocationInput(value);
    
    fetch(API_URL + `/api/search/locations?loc=${value}`)
      .then(res => res.json())
      .then(data => setLocations(data));
  };

  const showPickUp = () => {
    setShowPickupList(true);
  };

  const selectLocation = (name) => {
    setLocationInput(name);
    setShowPickupList(false);
    setLocations([]);
  };

  const hideData = (e) => {
    setKeyword(e.target.value)
  };

  const KeyListShow = (e) => {
    setShowKeyList(true)
    loadData()
  };

  const loadData = () => {
    fetch(API_URL + `/api/search/keyword?q=${keyword}&loc=${locationInput}`)
      .then(res => res.json())
      .then(data => {
        setDayTours(data.dayTours);
        setRoundTours(data.roundTours);
        setExcursions(data.excursions);
        setShowKeyList(true)
      })
  }

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setShowPickupList(false)
      }


      if (
        dropdownRefK.current &&
        !dropdownRefK.current.contains(event.target) &&
        inputRefK.current &&
        !inputRefK.current.contains(event.target)
      ) {
        setShowKeyList(false)
      }

    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => { document.removeEventListener("mousedown", handleClickOutside) }
  }, [])


  useEffect(() => {
    if (!keyword.trim()) {
      return
    }

    const timer = setTimeout(() => {
      loadData()
    }, 500)

    return () => { clearTimeout(timer) }
  }, [keyword])


  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="sli-frm loadSearch" id="loadSearch">
            <h2>Find Authentic Experiences</h2>

            <form action="/allSearchResult">
              <div className="loca">
                <input
                  type="text"
                  name="location"
                  className="browses"
                  placeholder="Pick up Location"
                  value={locationInput}
                  onKeyUp={searchPickUp}
                  onClick={showPickUp}
                  ref={inputRef}
                  onChange={(e) => setLocationInput(e.target.value)}
                />

                {showPickupList && (
                  <div className={"browses-list" + (showPickupList && locations.length > 0 ? " show" : "")} ref={dropdownRef}>
                    {locations.map((location, index) => (
                      <span
                        key={index}
                        onClick={() => selectLocation(location.name)}
                      >
                        {location.name}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              <div className="key">
                <input
                  type="text"
                  name="id"
                  className="remove-data get-input-length inphov"
                  placeholder='Search for Keyword “Sigirya” or “Kandy” etc.'
                  value={keyword}
                  onChange={hideData}
                  onClick={KeyListShow}
                  ref={inputRefK}
                />

                <div className={"serh-list full" + (showKeyList && getTourCheck(dayTours, roundTours, excursions) ? " show" : "")} id="sil-frm" ref={dropdownRefK}>

                  {dayTours.length > 0 ?
                    <div className="col-cus-4">
                      <div className="search-list-itme">
                        <div className="search-header-new">
                          DAY TOURS
                        </div>

                        <ul>
                          {dayTours.map((tour, index) => (
                            <li key={index}>
                              <a
                                href={`${url}day-tours/${tour.permalink}/${tour.id}/`}
                                target="_blank"
                                rel="noreferrer"
                                onClick={() => setShowKeyList(false)}
                              >
                                {tour.title}
                              </a>
                            </li>
                          ))}
                        </ul>

                      </div>
                    </div> : null}
                    
                  {roundTours.length > 0 ?
                    <div className="col-cus-4">
                      <div className="search-list-itme">
                        <div className="search-header-new">
                          ROUND TOURS
                        </div>

                        <ul>
                          {roundTours.map((tour, index) => (
                            <li key={index}>
                              <a
                                href={`${url}round-tours/${tour.itinerary_category?.name?.slug}/${tour.permalink}`}
                                target="_blank"
                                rel="noreferrer"
                                onClick={() => setShowKeyList(false)}
                              >
                                {tour.name}
                              </a>
                            </li>
                          ))}
                        </ul>

                      </div>
                    </div> : null}
                    
                  {excursions.length > 0 ?
                    <div className="col-cus-4">
                      <div className="search-list-itme">
                        <div className="search-header-new">
                          THINGS TO DO
                        </div>

                        <ul>
                          {excursions.map((item, index) => (
                            <li key={index}>
                              <a
                                href={`${url}things-to-do/${item.permalink}`}
                                target="_blank"
                                rel="noreferrer"
                                onClick={() => setShowKeyList(false)}
                              >
                                {item.name}
                              </a>
                            </li>
                          ))}
                        </ul>

                      </div>
                    </div> : null}

                  <span className="clear"></span>
                </div>
              </div>

              <input className="submit" type="submit" value="" />
              <div className="clear"></div>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
}